import React from "react";

import DonorCard from "../../DonorCard";
import DonationLevel from "../../DonationLevel";

const receiptDonorToDonorCard = (donor) => ({
  firstName: donor.firstName,
  lastName: donor.lastName,
  email: donor.email,
  phoneNumber: donor.phone,
  addressLine1: donor.address.line1,
  addressLine2: donor.address.line2,
  city: donor.address.city,
  state: donor.address.state,
  zip: donor.address.postalCode,
  country: donor.address.country,
});

const DonationCard = ({ donationLevel, donor,  promoTickets }) => {
  const donorCardDonor = receiptDonorToDonorCard(donor);

  return (
    <div>
      <DonationLevel donationLevel={donationLevel} promoTickets={promoTickets} selected emphasis />
      <DonorCard donor={donorCardDonor} />
    </div>
  );
};

export default DonationCard;
